export function parseReminderOffsetToMs(token: string): number | null {
  const m = token.trim().match(/^(\d+)(m|h|d|w)$/i);
  if (!m) return null;
  const n = Number(m[1]);
  if (!Number.isFinite(n) || n <= 0) return null;
  const u = m[2].toLowerCase();
  const minute = 60 * 1000;
  const hour = 60 * minute;
  const day = 24 * hour;
  switch (u) {
    case 'm':
      return n * minute;
    case 'h':
      return n * hour;
    case 'd':
      return n * day;
    case 'w':
      return n * 7 * day;
    default:
      return null;
  }
}

export function parseTripStartToDate(startDate: string): Date {
  const s = startDate.trim();
  if (s.includes('T')) {
    return new Date(s);
  }
  const parts = s.split('-').map(Number);
  if (parts.length === 3 && parts.every(n => Number.isFinite(n))) {
    const [y, mo, d] = parts;
    return new Date(y, mo - 1, d, 0, 0, 0, 0);
  }
  return new Date(s);
}

export function isReminderOffsetAllowedBeforeEvent(offsetToken: string, msUntilEventStart: number): boolean {
  if (msUntilEventStart <= 0) return false;
  const ms = parseReminderOffsetToMs(offsetToken);
  if (ms == null || ms <= 0) return false;
  return ms < msUntilEventStart;
}
